
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sexleketoy/womanizer",
      function () {
        return require("private-next-pages/sexleketoy/womanizer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sexleketoy/womanizer"])
      });
    }
  